// extracted by mini-css-extract-plugin
export default {"titleContainer":"StepDescription_titleContainer__-LV+v","editContainer":"StepDescription_editContainer__zFpho","edit":"StepDescription_edit__iq69z"};